import React from 'react';
import { Card, CardContent, Typography, CircularProgress, Tooltip, Box } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Grid from '@mui/material/Grid2';
import { observer } from 'mobx-react';
import dashboardStore from 'store/dashboardStore';
import M from 'messages';
import { ColorsMap } from './config/config';
import classes from './styles';

const KPISection = observer(() => (
  <Grid container spacing={2} sx={{ mt: 1 }}>
    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
      <Card>
        <CardContent sx={{ ...classes.KPICardContent, borderBottomColor: ColorsMap.visits }}>
          <Typography sx={classes.KPICardTitle} display="flex" alignItems="center">
            {M.get('dashboard.totalVisitsByMenu')}
            <Tooltip placement="top" title={M.get('dashboard.totalVisitsByMenuTooltip')}>
              <HelpOutlineIcon sx={classes.KPIHelpIcon} />
            </Tooltip>
          </Typography>
          {dashboardStore.KPIDataLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50px' }}>
              <CircularProgress />
            </Box>
          ) : (
            <Typography variant="h4" mt={1} sx={classes.KPICardValue}>
              {dashboardStore.timeTotalVisits}
            </Typography>
          )}
        </CardContent>
      </Card>
    </Grid>
    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
      <Card>
        <CardContent sx={{ ...classes.KPICardContent, borderBottomColor: ColorsMap.views }}>
          <Typography sx={classes.KPICardTitle} display="flex" alignItems="center">
            {M.get('dashboard.totalViewsByMenu')}
            <Tooltip placement="top" title={M.get('dashboard.totalViewsByMenuTooltip')}>
              <HelpOutlineIcon sx={classes.KPIHelpIcon} />
            </Tooltip>
          </Typography>
          {dashboardStore.KPIDataLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50px' }}>
              <CircularProgress />
            </Box>
          ) : (
            <Typography variant="h4" mt={1} sx={classes.KPICardValue}>
              {dashboardStore.totalViews}
            </Typography>
          )}
        </CardContent>
      </Card>
    </Grid>
    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
      <Card>
        <CardContent sx={{ ...classes.KPICardContent, borderBottomColor: ColorsMap.averageRating }}>
          <Typography sx={classes.KPICardTitle} display="flex" alignItems="center">
            {M.get('dashboard.averageRatingByMenu')}
            <Tooltip placement="top" title={M.get('dashboard.averageRatingByMenuTooltip')}>
              <HelpOutlineIcon sx={classes.KPIHelpIcon} />
            </Tooltip>
          </Typography>
          {dashboardStore.KPIDataLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50px' }}>
              <CircularProgress />
            </Box>
          ) : (
            <Typography variant="h4" mt={1} sx={classes.KPICardValue}>
              {Math.round(dashboardStore.timeAverageRating * 100) / 100}
            </Typography>
          )}
        </CardContent>
      </Card>
    </Grid>
    <Grid size={{ xs: 12, sm: 6, md: 3 }}>
      <Card>
        <CardContent sx={{ ...classes.KPICardContent, borderBottomColor: ColorsMap.ratings }}>
          <Typography sx={classes.KPICardTitle} display="flex" alignItems="center">
            {M.get('dashboard.totalRatingsByMenu')}
            <Tooltip placement="top" title={M.get('dashboard.totalRatingsByMenuTooltip')}>
              <HelpOutlineIcon sx={classes.KPIHelpIcon} />
            </Tooltip>
          </Typography>
          {dashboardStore.KPIDataLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50px' }}>
              <CircularProgress />
            </Box>
          ) : (
            <Typography variant="h4" mt={1} sx={classes.KPICardValue}>
              {dashboardStore.timeTotalRatings}
            </Typography>
          )}
        </CardContent>
      </Card>
    </Grid>
  </Grid>
));

export default KPISection;
